import * as R from 'ramda';
import moment from 'moment';
import { compareAsc } from 'date-fns/fp';


/**
 * sortMeetingNotesByDate :: [MeetingNote] -> [MeetingNote]
 */
export const sortMeetingNotesByDate = R.sortWith([
  (a, b) => compareAsc(a.meetingDate, b.meetingDate),
]);

/**
 * Merge date and time moments into a single date
 *
 * getMeetingDateByDateAndTime :: (Moment, Moment) -> Date
 */
export const getMeetingDateByDateAndTime = (date, time) => moment(date)
  .set('hours', time.hours())
  .set('minutes', time.minutes())
  .set('seconds', 0)
  .set('milliseconds', 0)
  .toDate();

/**
 * getMeetingAverageRating :: [Feedback] -> Number | Null
 */
export const getMeetingAverageRating = (feedback) => {
  const rating = !R.isNil(feedback)
    ? feedback.reduce((acc, { rate = 0 }) => acc + rate, 0)
    : 0;

  const totalFeedback = !R.isNil(feedback)
    ? feedback.reduce((acc, { rate }) => rate ? (acc + 1) : acc, 0)
    : 0;

  return (rating > 0 && totalFeedback > 0)
    ? rating / totalFeedback
    : null;
};



// WEBPACK FOOTER //
// ./src/utils/meeting-notes.js